<template>
  <layout-component>
    <div class="container">
      <div class="row form-wrapper pb-4 pb-md-2">
        <div class="col-md-7 col-lg-8 form form-login">
          <h1 class="br-title left-bullet" v-html="$t('w.forgot-password.title-banner')"></h1>
          <p class="br-title p-intro" v-html="$t('w.forgot-password.text-01')"></p>
          <div class="row">
            <div class="col-lg-9">

              <b-alert :show="has_error && !success" fade variant="danger">
                <h4><i class="fal fa-times"></i> {{'w.forgot-password.error-title'|t}}.</h4>
                <p>{{'w.forgot-password.error-text'|t}}</p>
              </b-alert>

              <b-alert :show="! has_error && success" fade variant="success">
                <h4><i class="fal fa-times"></i> {{'w.forgot-password.success-title'|t}}.</h4>
                <p>{{'w.forgot-password.success-text'|t}}</p>
              </b-alert>


              <form autocomplete="off" @submit.prevent="send" method="post">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <label for="email">{{'w.forgot-password.email-address'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="email" class="form-control" placeholder="user@example.com" v-model="email" required>
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center pt-2">
                  <button type="submit" class="btn btn-primary mt-0"><span>{{'w.forgot-password.btn-submit'|t}}</span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        email: null,
        password: null,
        has_error: false,
        success: false,
        redirectTo: null
      }
    },

    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
    },

    methods: {
      send() {
        this.has_error = false;
        this.success = false;
        Vue.axios.post('/password/email', {
          email: this.email
        }).then(({data}) => {
          this.success = true;
        }).catch(({error}) => {
          this.has_error = true;
        })
      }
    }
  }
</script>
